import { useEffect } from "react"


const ImageStatus = ({ open }) => {
    useEffect(() => {
        document.title = 'Images'
    }, [])

    let url = window.location.href
    let imagestatus = url.split('#')[1]

    return (
        <div className='container-fluid bg-dark pt-5' style={{ height: '100vh' }}>
            <div className='row'>
                <div className='col-sm-4 mx-auto my-5'>
                    <img src={imagestatus} alt='...' />
                </div>
            </div>
        </div>
    )
}
export default ImageStatus